import {Component, OnInit, OnDestroy} from '@angular/core';
import {MenuComponent} from '@cbui/components/shared/menu/menu';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {TranslocoModule} from '@jsverse/transloco';
import {PipesModule} from '@cbcore/pipes/pipes.module';
import {TrackingDirective} from '@cbui/helpers/directives/tracking.directive';

declare global {
  interface Window {
    fwSettings: {
      widget_id: number;
    };
    FreshworksWidget: any;
  }
}

@Component({
  selector: 'app-custom-menu',
  templateUrl: './custom-menu.html',
  styleUrls: ['./custom-menu.scss'],
  standalone: true,
  imports: [RouterModule, PipesModule, TranslocoModule, CommonModule, TrackingDirective]
})
export class CustomMenuComponent extends MenuComponent implements OnInit, OnDestroy {
  // Add custom properties or methods here to extend the behavior of the MenuComponent

  private scriptElement: HTMLScriptElement | null = null;
  private initCheckInterval: any;

  constructor() {
    super();
    // You can add constructor logic here if needed

    // Initialize settings
    window.fwSettings = {
      widget_id: 5000000633
    };

    // Initialize FreshworksWidget function
    if (typeof window.FreshworksWidget !== 'function') {
      const n = function() {
        // eslint-disable-next-line prefer-rest-params -- Freshworks' documented widget snippet expects the classic `arguments` object; not our code to modernize.
        (n as any).q.push(arguments);
      };
      (n as any).q = [];
      window.FreshworksWidget = n;
    }

  }

  ngOnInit() {
    this.loadWidget();
    this.checkWidgetInitialization();
  }

  private loadWidget() {
    // Create and append the script element
    this.scriptElement = document.createElement('script');
    this.scriptElement.type = 'text/javascript';
    this.scriptElement.src = 'https://widget.freshworks.com/widgets/5000000633.js';
    this.scriptElement.async = true;
    this.scriptElement.defer = true;
    document.head.appendChild(this.scriptElement);
  }

  private checkWidgetInitialization() {
    this.initCheckInterval = setInterval(() => {
      if (typeof window.FreshworksWidget === 'function') {
        console.log('Freshworks Widget has been initialized!');
        window.FreshworksWidget('hide', 'launcher');
        // You can emit an event here or call a method when widget is ready
        clearInterval(this.initCheckInterval);
      }
    }, 100); // Check every 100ms
  }

  ngOnDestroy() {
    // Clean up
    if (this.scriptElement && this.scriptElement.parentNode) {
      this.scriptElement.parentNode.removeChild(this.scriptElement);
    }
    if (this.initCheckInterval) {
      clearInterval(this.initCheckInterval);
    }
  }


  openHelp(): void {
    if (typeof window.FreshworksWidget === 'function') {
      window.FreshworksWidget('open');
    }
  }
}
